<div class="support-modal">
  <div class="modal-head">
    <div class="title-block">
      <h2>Contact support</h2>
      <span class="sub">Send us your question and we'll reply within a business day.</span>
    </div>
    <button class="close-btn" type="button" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Form state -->
  <ng-container *ngIf="!sent">
    <div class="support-hero">
      <div class="ico"><i class="bi bi-headset"></i></div>
      <div class="text">
        <span class="title">Writing to <strong>support&#64;clug.io</strong></span>
        <span class="sub-line">We'll loop in the right person and reply by email.</span>
      </div>
    </div>

    <div class="support-body">
      <div class="field">
        <label>Topic</label>
        <select class="form-control" [(ngModel)]="topic">
          <option *ngFor="let t of topics" [value]="t.value">{{ t.label }}</option>
        </select>
      </div>

      <div class="field">
        <label>Subject <span class="req">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="subject" [class.invalid]="subjectInvalid"
          (input)="subjectInvalid = false" placeholder="Give us a one-line summary" />
      </div>

      <div class="field">
        <label>Message <span class="req">*</span></label>
        <textarea class="form-control" rows="6" [(ngModel)]="message" [class.invalid]="messageInvalid"
          (input)="messageInvalid = false"
          placeholder="Describe what you were trying to do, what happened, and what you expected. Screenshots help — attach below."></textarea>
      </div>

      <div class="field attach-field">
        <label class="attach-btn">
          <i class="bi bi-paperclip"></i>
          <span>{{ attachmentLabel }}</span>
          <input type="file" hidden (change)="onFileSelected($event)" />
        </label>
      </div>

      <div class="diag-card">
        <div class="diag-text">
          <span class="diag-title">Include diagnostic info</span>
          <div class="diag-chips">
            <span class="diag-chip"><i class="bi bi-person"></i>{{ userRoleLabel }}</span>
            <span class="diag-chip"><i class="bi bi-link-45deg"></i>{{ pageLabel }}</span>
            <span class="diag-chip"><i class="bi bi-laptop"></i>Browser</span>
          </div>
        </div>
        <span class="switch" [class.on]="includeDiagnostic" (click)="toggleDiagnostic()"></span>
      </div>

      <div *ngIf="errorMessage" class="error-msg">{{ errorMessage }}</div>
    </div>

    <div class="modal-foot">
      <div class="left">
        <i class="bi bi-shield-check"></i>
        <span>Replies go to <strong>{{ userEmail }}</strong></span>
      </div>
      <div class="right">
        <button class="btn btn-secondary" type="button" (click)="close()" [disabled]="sending">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="send()" [disabled]="sending">
          <span *ngIf="sending" class="spin"></span>
          <ng-container *ngIf="!sending"><i class="bi bi-send"></i>Send message</ng-container>
          <ng-container *ngIf="sending">Sending…</ng-container>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Success state -->
  <ng-container *ngIf="sent">
    <div class="support-success">
      <div class="ok-ico"><i class="bi bi-check-lg"></i></div>
      <h3>Message sent</h3>
      <p>Thanks for reaching out. We'll reply to <strong>{{ userEmail }}</strong><br />within one business day.</p>
      <div class="ref"><i class="bi bi-hash"></i><span>{{ ticketId }}</span></div>
    </div>
    <div class="modal-foot">
      <div class="left"></div>
      <div class="right">
        <button class="btn btn-primary" type="button" (click)="close()">Done</button>
      </div>
    </div>
  </ng-container>
</div>